import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Log from '../../assets/images/logout1.png';
import Log1 from '../../assets/images/logout2.png';
import api from '../../service/caller';
import {getUserIdFromToken} from '../../utils/authUtils';

const InvoiceModal = ({ showModal, invoiceData, onClose, appointment }) => {
    const { services, totalPrice } = invoiceData;

    // Fonction pour télécharger la facture en PDF
    const handleDownload = async () => {
        const paymentData = {
            operationtype: 'Service offered',
            OperationId: appointment._id,
            operationRef: "Appointment",
            caissiereId: getUserIdFromToken(),
            patientId: appointment.patientId,
            amount: totalPrice,
            currency: 'FCFA',
            purpose: 'Consultation Fee',
            department: appointment.department,
            hospitalId: appointment.hospitalId,
          };
      
          const paymentResponse = await api.post('/clinic/createPayment', paymentData);
        const element = document.querySelector('.myfacture');  // Cibler le modal pour l'impression
        if (!element) return;

        try {
            // Utilisation de html2canvas pour capturer le contenu du modal
            const canvas = await html2canvas(element, {
                scale: 2,  // Résolution améliorée pour l'image
                useCORS: true,  // Gérer les images externes (CORS)
                backgroundColor: '#ffffff',  // Assurez-vous que le fond est blanc
            });

            const imgData = canvas.toDataURL('image/jpeg', 1.0);  // Convertir le canvas en image JPEG
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',  // Format A4
            });

            // Déterminer la taille de l'image dans le PDF
            const imgWidth = 210;  // Largeur A4 en mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;  // Calcul de la hauteur proportionnelle

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);  // Ajouter l'image dans le PDF

            // Sauvegarder le PDF avec un nom basé sur l'ID du patient
            pdf.save(`facture_Invoice.pdf`);
        } catch (error) {
            console.error('Erreur de génération du PDF:', error);
        }
    };

    return (
        <Modal show={showModal} onHide={onClose} size="xl" scrollable>
            <Modal.Header closeButton>
                <Modal.Title className="text-center">Facture de Consultation</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: 'auto', textAlign: 'center' }}>

                <div className='myfacture'>
                    <table
                        className="table table-bordered"
                        style={{ margin: '0 auto', width: '80%', borderCollapse: 'collapse' }}  // Ajout de borderCollapse pour des lignes visibles
                    >
                        <thead>
                            <tr>
                                <th className="text-center" style={{ border: '1px solid black' }}>Service</th>
                                <th className="text-center" style={{ border: '1px solid black' }}>Prix Unitaire</th>
                                <th className="text-center" style={{ border: '1px solid black' }}>Quantité</th>
                                <th className="text-center" style={{ border: '1px solid black' }}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {services.map((service, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid black' }}>{service.name}</td>
                                    <td style={{ border: '1px solid black' }}>{service.price} XOF</td>
                                    <td style={{ border: '1px solid black' }}>{service.quantity}</td>
                                    <td style={{ border: '1px solid black' }}>{service.total} XOF</td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan="3" className="text-center" style={{ border: '1px solid black' }}>Total</td>
                                <td style={{ border: '1px solid black' }}>{totalPrice} XOF</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                {/* Boutons visibles pour l'utilisateur */}
                <div className="d-flex justify-content-center gap-4 mt-4">
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        className="d-flex align-items-center px-4 py-2 shadow"
                        style={{ background: '#1A5D1A' }}
                    >
                        Fermer <img src={Log} className='ms-2' alt="Go back" />
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleDownload}  // Le bouton est visible mais ne sera pas inclus dans l'impression
                        className="d-flex align-items-center px-4 py-2 shadow"
                    >
                        Imprimer <img src={Log1} className='ms-2' alt="Save" />
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default InvoiceModal;
